<template>
  <BuiEntityListingPage
    v-bind="listNamesConfig"
    :ItemsLister="PlaylistsLister"
    :itemsListerBind="{ buiColumns: playlistsColumns }"
    :createItemPage="canCreate"
    @create="createDialog?.openModal()"
  />

  <!--
    Create Playlist modal — the Phase 3 create-modal template: the shared
    Dialog.vue (Headless UI) wrapper hosting a BUI-styled form. The listing
    page's primary action only emits `create` (createItemPage), so the
    legacy in-page create overlay is not used; `canCreate` keeps the same
    area-access gate the overlay flow applied.
  -->
  <Dialog ref="createDialog" panelClass="bui-dialog-panel">
    <template #dialog.title>Create Playlist</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <CreatePlaylistForm @cancel="closeModal" @success="closeModalAfter(1000)" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import Dialog from '@/components/Dialog/Dialog.vue';
import CreatePlaylistForm from './CreatePlaylistForm/CreatePlaylistForm.vue';
import PlaylistsLister from './PlaylistsLister/PlaylistsLister.vue';
import listNamesConfig from "./PlaylistsLister/config/listNames.config";
import playlistsColumns from "./PlaylistsLister/config/tableColumns.config";
import useUser from '@/composables/user';

const user = useUser();
const createDialog = ref();
const canCreate = computed(() => user.hasCreateAccessToArea(listNamesConfig.areaAccessName));
</script>
